export const USER_CAMPAIGN_GET_REQUESTING = "USER_CAMPAIGN_GET_REQUESTING";
export const USER_CAMPAIGN_GET_SUCCESS = "USER_CAMPAIGN_GET_SUCCESS";
export const USER_CAMPAIGN_GET_ERROR = "USER_CAMPAIGN_GET_ERROR";

export const USER_CAMPAIGN_GET_ALL_REQUESTING =
  "USER_CAMPAIGN_GET_ALL_REQUESTING";
export const USER_CAMPAIGN_GET_ALL_SUCCESS = "USER_CAMPAIGN_GET_ALL_SUCCESS";
export const USER_CAMPAIGN_GET_ALL_ERROR = "USER_CAMPAIGN_GET_ALL_ERROR";

export const USER_CAMPAIGN_SELECT = "USER_CAMPAIGN_SELECT";

export const USER_CAMPAIGN_GET_TEAM_REQUESTING =
  "USER_CAMPAIGN_GET_TEAM_REQUESTING";
export const USER_CAMPAIGN_GET_TEAM_SUCCESS = "USER_CAMPAIGN_GET_TEAM_SUCCESS";
export const USER_CAMPAIGN_GET_TEAM_ERROR = "USER_CAMPAIGN_GET_TEAM_ERROR";

export const USER_CAMPAIGN_NEW = "USER_CAMPAIGN_NEW";

export const SELECT_PERFECT_STEP_REQUESTING = "SELECT_PERFECT_STEP_REQUESTING";
export const SELECT_PERFECT_STEP_SUCCESS = "SELECT_PERFECT_STEP_SUCCESS";
export const SELECT_PERFECT_STEP_ERROR = "SELECT_PERFECT_STEP_ERROR";

export const GET_SPECIFIC_STEP_REQUESTING = "GET_SPECIFIC_STEP_REQUESTING";
export const GET_SPECIFIC_STEP_SUCCESS = "GET_SPECIFIC_STEP_SUCCESS";
export const GET_SPECIFIC_STEP_ERROR = "GET_SPECIFIC_STEP_ERROR";

export const SELECT_RECOMMENDED_STEPS_REQUESTING =
  "userCampaign/SELECT_RECOMMENDED_STEPS_REQUESTING";
export const SELECT_RECOMMENDED_STEPS_SUCCESS =
  "userCampaign/SELECT_RECOMMENDED_STEPS_SUCCESS";
export const SELECT_RECOMMENDED_STEPS_ERROR =
  "userCampaign/SELECT_RECOMMENDED_STEPS_ERROR";

export const ACCEPT_PERFECT_STEP_REQUESTING = "ACCEPT_PERFECT_STEP_REQUESTING";
export const ACCEPT_PERFECT_STEP_SUCCESS = "ACCEPT_PERFECT_STEP_SUCCESS";
export const ACCEPT_PERFECT_STEP_ERROR = "ACCEPT_PERFECT_STEP_ERROR";

export const VALIDATE_PERFECT_STEP_REQUESTING =
  "VALIDATE_PERFECT_STEP_REQUESTING";
export const VALIDATE_PERFECT_STEP_SUCCESS = "VALIDATE_PERFECT_STEP_SUCCESS";
export const VALIDATE_PERFECT_STEP_ERROR = "VALIDATE_PERFECT_STEP_ERROR";

export const SELECT_STEP = "SELECT_STEP";

export const USER_CAMPAIGN_SET_USER_RANK = "USER_CAMPAIGN_SET_USER_RANK";
export const USER_CAMPAIGN_SET_TEAM_RANK = "USER_CAMPAIGN_SET_TEAM_RANK";

export const USER_CAMPAIGN_SET_TEAM = "USER_CAMPAIGN_SET_TEAM";

export const USER_CAMPAIGN_DELETE = "USER_CAMPAIGN_DELETE";

export const USER_CAMPAIGN_GET_USER_RANK_REQUESTING =
  "USER_CAMPAIGN_GET_USER_RANK_REQUESTING";
export const USER_CAMPAIGN_GET_USER_RANK_SUCCESS =
  "USER_CAMPAIGN_GET_USER_RANK_SUCCESS";
export const USER_CAMPAIGN_GET_USER_RANK_ERROR =
  "USER_CAMPAIGN_GET_USER_RANK_ERROR";

export const USER_CAMPAIGN_GET_TEAM_RANK_REQUESTING =
  "USER_CAMPAIGN_GET_TEAM_RANK_REQUESTING";
export const USER_CAMPAIGN_GET_TEAM_RANK_SUCCESS =
  "USER_CAMPAIGN_GET_TEAM_RANK_SUCCESS";
export const USER_CAMPAIGN_GET_TEAM_RANK_ERROR =
  "USER_CAMPAIGN_GET_TEAM_RANK_ERROR";

export const USER_CAMPAIGN_SET_NEXT_CATEGORY_REQUESTING =
  "USER_CAMPAIGN_SET_NEXT_CATEGORY_REQUESTING";
export const USER_CAMPAIGN_SET_NEXT_CATEGORY_ERROR =
  "USER_CAMPAIGN_SET_NEXT_CATEGORY_ERROR";
export const USER_CAMPAIGN_SET_NEXT_CATEGORY_SUCCESS =
  "USER_CAMPAIGN_SET_NEXT_CATEGORY_SUCCESS";

export const GET_EVENTS_REQUESTING = "GET_EVENTS_REQUESTING";
export const GET_EVENTS_ERROR = "GET_EVENTS_ERROR";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";

export const GET_CURRENT_USER_CAMPAIGN_REQUESTING =
  "GET_CURRENT_USER_CAMPAIGN_REQUESTING";
export const GET_CURRENT_USER_CAMPAIGN_SUCCESS =
  "GET_CURRENT_USER_CAMPAIGN_SUCCESS";
export const GET_CURRENT_USER_CAMPAIGN_ERROR =
  "GET_CURRENT_USER_CAMPAIGN_ERROR";

export const CAMPAIGN_JOIN_REQUESTING = "userCampaign/CAMPAIGN_JOIN_REQUESTING";
export const CAMPAIGN_JOIN_SUCCESS = "userCampaign/CAMPAIGN_JOIN_SUCCESS";
export const CAMPAIGN_JOIN_ERROR = "userCampaign/CAMPAIGN_JOIN_ERROR";

export const GET_CAMPAIGN_REVIEWS_REQUESTING =
  "userCampaign/GET_CAMPAIGN_REVIEWS_REQUESTING";
export const GET_CAMPAIGN_REVIEWS_SUCCESS =
  "userCampaign/GET_CAMPAIGN_REVIEWS_SUCCESS";
export const GET_CAMPAIGN_REVIEWS_ERROR =
  "userCampaign/GET_CAMPAIGN_REVIEWS_ERROR";

export const UPDATE_REVIEW_REQUESTING = "userCampaign/UPDATE_REVIEW_REQUESTING";
export const UPDATE_REVIEW_SUCCESS = "userCampaign/UPDATE_REVIEW_SUCCESS";
export const UPDATE_REVIEW_ERROR = "userCampaign/UPDATE_REVIEW_ERROR";

export const COMMENT_REVIEW_REQUESTING =
  "userCampaign/COMMENT_REVIEW_REQUESTING";
export const COMMENT_REVIEW_SUCCESS = "userCampaign/COMMENT_REVIEW_SUCCESS";
export const COMMENT_REVIEW_ERROR = "userCampaign/COMMENT_REVIEW_ERROR";

export const SEE_COMMENTS_REVIEW_REQUESTING =
  "userCampaign/SEE_COMMENTS_REVIEW_REQUESTING";
export const SEE_COMMENTS_REVIEW_SUCCESS =
  "userCampaign/SEE_COMMENTS_REVIEW_SUCCESS";
export const SEE_COMMENTS_REVIEW_ERROR =
  "userCampaign/SEE_COMMENTS_REVIEW_ERROR";

export const SELECT_FEEDBACK_ID = "userCampaign/SELECT_FEEDBACK_ID";
export const SELECT_FEEDBACK_FROM_STEP_ID =
  "userCampaign/SELECT_FEEDBACK_FROM_STEP_ID";

export const UPDATE_STEP_FEEDBACK_FILE = "UPDATE_STEP_FEEDBACK_FILE";

export const CANCEL_SELECTED_STEP_REQUESTING =
  "userCampaign/CANCEL_SELECTED_STEP_REQUESTING";
export const CANCEL_SELECTED_STEP_SUCCESS =
  "userCampaign/CANCEL_SELECTED_STEP_SUCCESS";
export const CANCEL_SELECTED_STEP_ERROR =
  "userCampaign/CANCEL_SELECTED_STEP_ERROR";

// ^^ step Comment
export const ADD_STEP_COMMENT_REQUESTING =
  "userCampaign/ADD_STEP_COMMENT_REQUESTING";
export const ADD_STEP_COMMENT_ERROR = "userCampaign/ADD_STEP_COMMENT_ERROR";
export const ADD_STEP_COMMENT_SUCCESS = "userCampaign/ADD_STEP_COMMENT_SUCCESS";

export const REMOVE_COMMENT_REQUESTING =
  "userCampaign/REMOVE_COMMENT_REQUESTING";
export const REMOVE_COMMENT_ERROR = "userCampaign/REMOVE_COMMENT_ERROR";
export const REMOVE_COMMENT_SUCCESS = "userCampaign/REMOVE_COMMENT_SUCCESS";

export const UPDATE_COMMENT_REQUESTING =
  "userCampaign/UPDATE_COMMENT_REQUESTING";
export const UPDATE_COMMENT_ERROR = "userCampaign/UPDATE_COMMENT_ERROR";
export const UPDATE_COMMENT_SUCCESS = "userCampaign/UPDATE_COMMENT_SUCCESS";

export const GET_STEP_COMMENT_REQUESTING =
  "userCampaign/GET_STEP_COMMENT_REQUESTING";
export const GET_STEP_COMMENT_ERROR = "userCampaign/GET_STEP_COMMENT_ERROR";
export const GET_STEP_COMMENT_SUCCESS = "userCampaign/GET_STEP_COMMENT_SUCCESS";

export const GET_STEP_COMMENT_INFO_REQUESTING =
  "userCampaign/GET_STEP_COMMENT_INFO_REQUESTING";
export const GET_STEP_COMMENT_INFO_ERROR =
  "userCampaign/GET_STEP_COMMENT_INFO_ERROR";
export const GET_STEP_COMMENT_INFO_SUCCESS =
  "userCampaign/GET_STEP_COMMENT_INFO_SUCCESS";

// ^^ answer step comment
export const GET_ALL_RESPONSES_REQUESTING =
  "userCampaign/GET_ALL_RESPONSES_REQUESTING";
export const GET_ALL_RESPONSES_ERROR = "userCampaign/GET_ALL_RESPONSES_ERROR";
export const GET_ALL_RESPONSES_SUCCESS =
  "userCampaign/GET_ALL_RESPONSES_SUCCESS";

export const SEND_RESPONSE_REQUESTING = "userCampaign/SEND_RESPONSE_REQUESTING";
export const SEND_RESPONSE_ERROR = "userCampaign/SEND_RESPONSE_ERROR";
export const SEND_RESPONSE_SUCCESS = "userCampaign/SEND_RESPONSE_SUCCESS";

// ^^ like step comment
export const REMOVE_LIKE_STEP_COMMENT_REQUESTING =
  "userCampaign/REMOVE_LIKE_STEP_COMMENT_REQUESTING";
export const REMOVE_LIKE_STEP_COMMENT_ERROR =
  "userCampaign/REMOVE_LIKE_STEP_COMMENT_ERROR";
export const REMOVE_LIKE_STEP_COMMENT_SUCCESS =
  "userCampaign/REMOVE_LIKE_STEP_COMMENT_SUCCESS";

export const ADD_LIKE_STEP_COMMENT_REQUESTING =
  "userCampaign/ADD_LIKE_STEP_COMMENT_REQUESTING";
export const ADD_LIKE_STEP_COMMENT_ERROR =
  "userCampaign/ADD_LIKE_STEP_COMMENT_ERROR";
export const ADD_LIKE_STEP_COMMENT_SUCCESS =
  "userCampaign/ADD_LIKE_STEP_COMMENT_SUCCESS";
